module.exports = __webpack_public_path__ + "static/img/GP.24fd396f.svg";